module.exports = require("plotly.js/src/locale-en");